module.exports = __webpack_public_path__ + "img/facts-all_1994.26ddc33a.png";